/**
 * @desc 渠道计费规则报表导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.logisticsChannelPrice.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelPrice/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
